import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Services = lazy(() => import('../pages/services/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const PortfolioCase = lazy(() => import('../pages/portfolio/case'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogPost = lazy(() => import('../pages/blog/post'));
const Post1Presentation = lazy(() => import('../pages/blog/presentations/post1-presentation'));
const Post2Presentation = lazy(() => import('../pages/blog/presentations/post2-presentation'));
const Post5Presentation = lazy(() => import('../pages/blog/presentations/post5-presentation'));
const Post10Presentation = lazy(() => import('../pages/blog/presentations/post10-presentation'));
const About = lazy(() => import('../pages/about/page'));
const AdminReviews = lazy(() => import('../pages/admin/reviews/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Oplata = lazy(() => import('../pages/oplata/page'));
const PayRedirect = lazy(() => import('../pages/pay/page'));
const AdminSetup = lazy(() => import('../pages/admin/setup/page'));
const Zayavka = lazy(() => import('../pages/zayavka/page'));
const ClientAdvertisingCabinet = lazy(() => import('../pages/cabinet/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/portfolio/:id',
    element: <PortfolioCase />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/:id',
    element: <BlogPost />,
  },
  {
    path: '/blog/1/presentation',
    element: <Post1Presentation />,
  },
  {
    path: '/blog/2/presentation',
    element: <Post2Presentation />,
  },
  {
    path: '/blog/5/presentation',
    element: <Post5Presentation />,
  },
  {
    path: '/blog/10/presentation',
    element: <Post10Presentation />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/admin/reviews',
    element: <AdminReviews />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/oplata',
    element: <Oplata />,
  },
  {
    path: '/pay/:code',
    element: <PayRedirect />,
  },
  {
    path: '/zayavka',
    element: <Zayavka />,
  },
  {
    path: '/cabinet/:access',
    element: <ClientAdvertisingCabinet />,
  },
  {
    path: '/admin/setup',
    element: <AdminSetup />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;